import { Skeleton, Text } from '@electricjs/arc';
import { Trans } from 'react-i18next';

import i18n from '@/i18n';
import { NotificationIcon } from '../NotificationIcon';
import { NotificationItemHeader } from '../NotificationItemHeader';
import { NotificationItemProps } from '../types';
import { useGetRequestData } from '@/hooks/useGetRequestData';
import formatDate from '@/helpers/formatDate';
import { RenewMdmCertButton } from '@/components/Tasks/Actions/RenewMdmCertButton';

const MdmCertificateAboutToExpireNotificationItem = ({
  notification,
  hideDetails,
}: NotificationItemProps) => {
  const { data: requestData, isLoading } = useGetRequestData({
    requestId: notification?.data?.request_id ?? null,
  });

  if (isLoading) return <Skeleton />;

  const title = (
    <Text fontSize={'14px'} pb={'1rem'}>
      <Trans
        i18nKey="notificationItems.mdmCertificateAboutToExpire.title"
        ns="common"
        values={{ expiresAt: formatDate(requestData.request?.data.expiresAt) }}
        components={{ bold: <b /> }}
      />
    </Text>
  );

  return (
    <NotificationItemHeader
      notification={notification}
      title={title}
      icon={
        <NotificationIcon
          isNotificationUnseen={!notification.seenAt}
          icon="alert-triangle"
          intent="warning"
        />
      }
      label={i18n.t('common:notificationItems.labels.deviceManagement')}>
      {!hideDetails ? <RenewMdmCertButton /> : null}
    </NotificationItemHeader>
  );
};

export default MdmCertificateAboutToExpireNotificationItem;
